import { render } from "./ClientNew.vue?vue&type=template&id=0b46c9fe"
import script from "./ClientNew.vue?vue&type=script&lang=js"
export * from "./ClientNew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__